import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const ListHeader = styled.h2`
  flex: 0 0 auto;
  padding: 12px 0 8px 0;
  position: relative;
  border-bottom: 1px solid #d3d3d3;
  margin: 0 10px;
  text-transform: capitalize;
  font-size: 1em;
  font-weight: 500;
  transition: 0.2s ease-in-out;
`;

export const ListContent = styled.div`
  border: 2px solid #fff;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  position: relative;
  white-space: normal;
  background-color: ${(props) =>
    props.isDraggingOver ? "#d2d2d2 !important" : "#fff"};

  ${ListHeader} {
    border-bottom: ${(props) => props.isDraggingOver && "1px solid #fff"};
  }
`;

export const Column = styled.div`
  width: 300px;
  margin: 0 5px;
  height: 100%;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;

  &:nth-child(1) {
    margin-left: 10px;
  }

  &:last-child {
    margin-right: 10px;
  }

  &#rejected-candidates {
    ${ListContent} {
      background: #e8e8e8;
    }

    .kanban-card {
      background: #dadada;
      border: 1px solid white;

      .kanban-card-wrapper {
        padding: 6px 12px 8px 12px;
      }

      .kanban-candidate-link {
        right: 18px;
        color: #949494 !important;
      }

      .card-title,
      .card-content {
        color: #545454;
      }

      &:hover {
        background: #dadada;
        border: 1px solid white;
      }

      svg {
        display: none;
      }
    }

    .kanban-card.unread-true {
      border: 1px solid #fff !important;
    }

    [data-react-beautiful-dnd-droppable] {
      background: #e8e8e8;
    }
  }

  ${mediaMaxWidth.phone`
    scroll-snap-align: ${(props) =>
      props.draggingActive ? "unset" : "center"};
  `}
`;

export const ListCards = styled.div`
  flex: 1 1 auto;
  margin-bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 4px;
  padding: 0 4px;
  min-height: calc(100vh - 222px);
  padding-bottom: ${(props) => (props.isDraggingOver ? "10px" : "0")};
  transition: 0.2s ease-in-out;

  ${mediaMaxWidth.tablet`
    min-height: ${(props) =>
      props.iOS ? "calc(100vh - 240px);" : "calc(100vh - 167px);"};
  `}
`;

export const SubmittedCount = styled.span`
  color: #27ae60;
  font-weight: 600;
  position: relative;
  top: -1px;
  left: 2px;
`;

export const SubmitCandidateLink = styled.a`
  position: absolute;
  right: 0;
  top: 7px;
  transition: 0.1s ease-in-out;

  svg {
    font-size: 1.3em;
  }

  &:hover {
    svg {
      color: #402680;
    }
  }
`;

export { Column as default };
